import { Dispatch, SetStateAction, useMemo, useState } from "react";

import { BrieGPTTabs } from "../BrieGPTSidebarElements/Types";
import useUser from "../../../../api/api-hooks/auth/useUser";
import IconButton from "../../../../elements/IconButton";
import ProjectMembersModal from "./ProjectMembersModal";
import { BrieGPTProject } from "../useBrieGPTItems";
import MembersList from "./MembersList";

interface ProjectListMembersProps {
  project: BrieGPTProject;
  tab: BrieGPTTabs;
  setTab: Dispatch<SetStateAction<BrieGPTTabs>>;
  /** The View or Record ID which the Project is associated with. */
  itemID: string;
}

function ProjectListMembers({
  project,
  tab,
  setTab,
  itemID,
}: ProjectListMembersProps) {
  const [open, setOpen] = useState(false);

  const { user } = useUser();
  const rawMembers = useMemo(() => {
    // In case there are no members and the owner is not in it.
    if (!project?.Members) {
      return [
        {
          Member: {
            id: project?.CreatedBy,
            _RecordName: user?._RecordName,
            _ModuleAPIName: "Contacts",
          },
          Owner: true,
        },
      ];
    }

    return project?.Members;
  }, [project?.Members]);

  const isOwner = useMemo(() => {
    const members = rawMembers;
    const memberIDs = rawMembers?.map((m) => m?.Member?.id);

    if (!memberIDs?.length) {
      return project.CreatedBy === user?.id;
    }

    return members?.some((m) => m.Member?.id === user?.id && !!m.Owner);
  }, [rawMembers, user]);

  if (!project || !user) return null;

  return (
    <>
      <span className="tw:font-bold tw:text-light tw:text-sm mb-2">
        Members
      </span>
      <div className="tw:flex tw:justify-between tw:items-center tw:pb-3 mb-3">
        <MembersList project={project} />
        {isOwner && (
          <IconButton
            icon="account-multiple-plus"
            color="primary"
            onClick={() => setOpen(true)}
          />
        )}
      </div>
      <ProjectMembersModal
        open={open}
        onClose={onClose}
        project={project}
        isOwner={isOwner}
        user={user}
        tab={tab}
        setTab={setTab}
        itemID={itemID}
      />
    </>
  );

  function onClose() {
    setOpen(false);
  }
}

export default ProjectListMembers;
